(function () {
  const STORAGE_KEY = 'dj_recently_viewed_products_v1';
  const MAX_STORED = 14;

  function readStorage() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeStorage(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
    } catch (error) {
      // Ignore private-mode/localStorage failures.
    }
  }

  function normaliseItem(item) {
    if (!item || !item.handle || !item.title || !item.url) return null;
    return {
      id: item.id || item.handle,
      handle: item.handle,
      title: item.title,
      vendor: item.vendor || '',
      url: item.url,
      image: item.image || '',
      image_alt: item.image_alt || item.title,
      price: item.price || '',
      compare_at_price: item.compare_at_price || ''
    };
  }

  function getCurrent(section) {
    const script = section.querySelector('[data-dj-rv-current]');
    if (!script) return null;
    try {
      return normaliseItem(JSON.parse(script.textContent || '{}'));
    } catch (error) {
      return null;
    }
  }

  function uniqueItems(items) {
    const seen = new Set();
    const unique = [];
    items.forEach((item) => {
      const normalised = normaliseItem(item);
      if (!normalised || seen.has(normalised.handle)) return;
      seen.add(normalised.handle);
      unique.push(normalised);
    });
    return unique;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cardHtml(item) {
    const image = item.image
      ? `<img class="dj-rv__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.image_alt || item.title)}" loading="lazy" width="360" height="480">`
      : '<span class="dj-rv__image"></span>';

    const price = item.compare_at_price
      ? `<span class="dj-rv__price-compare">${escapeHtml(item.compare_at_price)}</span><span>${escapeHtml(item.price)}</span>`
      : `<span>${escapeHtml(item.price)}</span>`;

    return `<article class="dj-rv__card">
      <a class="dj-rv__card-link" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">
        <span class="dj-rv__image-wrap">${image}</span>
        <span class="dj-rv__meta">
          <span class="dj-rv__vendor">${escapeHtml(item.vendor)}</span>
          <span class="dj-rv__title">${escapeHtml(item.title)}</span>
          <span class="dj-rv__price">${price}</span>
        </span>
      </a>
    </article>`;
  }

  function getLimit(section) {
    const desktop = parseInt(section.dataset.desktopLimit || '5', 10) || 5;
    const mobile = parseInt(section.dataset.mobileLimit || '6', 10) || 6;
    return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;
  }

  function render(section) {
    const currentHandle = section.dataset.currentHandle || '';
    const grid = section.querySelector('[data-dj-rv-grid]');
    if (!grid) return;

    const items = uniqueItems(readStorage()).filter((item) => item.handle !== currentHandle);
    const visibleItems = items.slice(0, getLimit(section));

    if (!visibleItems.length) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }

    grid.innerHTML = visibleItems.map(cardHtml).join('');
    section.hidden = false;
  }

  function rememberCurrent(section) {
    const current = getCurrent(section);
    if (!current) return;

    const existing = readStorage().filter((item) => item && item.handle !== current.handle);
    writeStorage(uniqueItems([current].concat(existing)));
  }

  function initSection(section) {
    render(section);
    rememberCurrent(section);

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => render(section), 120);
    });
  }

  function init() {
    document.querySelectorAll('[data-dj-recently-viewed]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();